/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'undo': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(9 10)" _stroke="#00272E"><path pid="0" d="M0 4.145h11.25c2.071 0 3.75 1.759 3.75 3.928S13.321 12 11.25 12H9.375"/><polyline pid="1" points="3.75 8.07010909 0 4.14283636 3.75 0.215563636"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/undo.js